module.exports = __webpack_public_path__ + "img/adv-bird-3.13b3a28b.png";